import { useState, useMemo } from 'react'
import { message as $message } from 'antd'
import { querySupplierConfig } from '@/services/partnership'

export default () => {
    const [supplierPublicMap, setSupplierPublicMap] = useState(() => ({}))
    const [currentSupplierCoId, setCurrentSupplierCoId] = useState(null)

    const currentIsPublic = useMemo(() => {
        return currentSupplierCoId && supplierPublicMap[currentSupplierCoId]
    }, [supplierPublicMap, currentSupplierCoId])

    const querySupplierPublic = async coIdList => {
        const { success, data, message } = await querySupplierConfig(coIdList)
        if (!success) {
            $message.error(message)
            return
        }
        setSupplierPublicMap({
            ...supplierPublicMap,
            ...coIdList.reduce((result, coId, index) => {
                result[coId] = data?.[index]?.makePublic
                return result
            }, {}),
        })
    }

    return {
        supplierPublicMap,
        currentSupplierCoId,
        currentIsPublic,
        setCurrentSupplierCoId,
        querySupplierPublic,
    }
}
